export const AFFILIATE_ADD_ITEM = "AFFILIATE_ADD_ITEM";
export const AFFILIATE_UPDATE_ITEM = "AFFILIATE_UPDATE_ITEM";
export const AFFILIATE_GET_ITEMS = "AFFILIATE_GET_ITEMS";
export const AFFILIATE_DELETE_ITEM = "AFFILIATE_DELETE_ITEM";
export const GET_AFFILIATE_PROGRAM_USER = "GET_AFFILIATE_PROGRAM_USER";
export const AFFILIATE_PAY_WIN = "AFFILIATE_PAY_WIN";
export const AFFILIATE_SEND_MESSAGE = "AFFILIATE_SEND_MESSAGE";
export const AFFILIATE_VALIDATE_USER = "AFFILIATE_VALIDATE_USER";
export const AFFILIATE_CHANGE_USER_STATUS = "AFFILIATE_CHANGE_USER_STATUS";